/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import './ReservationView.scss'
import React from 'react'
import { Edit } from '../../molecules'
import ReservationSegmentAction from '../../../action/reservation_segment'

export default props => {
  const reservation_id = props.edit.reservation_id
  const segment_category_options = props.segment_category_options
  const reservation_segments = props.reservation_segments
  return (
    <Edit title={`客層登録`} buttonLabel={'登録'} onSubmit={() => ReservationSegmentAction.onRequestSave(reservation_id, reservation_segments)} onCancel={ReservationSegmentAction.cancelEditView}>
      {segment_category_options &&
        segment_category_options.map(category => (
          <div className="EditArea__row">
            <div className="EditArea__row--full">
              <div className="EditArea__column">
                <>
                  <p className="input-required">{category.name}</p>
                  <div class="segment">
                    {category &&
                      category.segment_value_options.map(value => (
                        <>
                          <input
                            type="radio"
                            name={category.id}
                            id={`${category.id}-${value.id}`}
                            value={value.id}
                            onClick={() => ReservationSegmentAction.onEdit(category.id, value.id)}
                            checked={checked(reservation_segments, category.id, value.id)}
                          />
                          <label for={`${category.id}-${value.id}`}>{value.name}</label>
                        </>
                      ))}
                  </div>
                </>
              </div>
            </div>
          </div>
        ))}
    </Edit>
  )
}

function checked(segments, category_id, value_id) {
  return segments.some(s => s.segment_category_id === category_id && s.segment_value_id === value_id)
}
